import Slider from "../MyComponents/Slider";
import Categories from "../MyComponents/Categories";
import Qualities from "../MyComponents/Qualitites";
import { useEffect } from "react";
import { useLoading } from "../assets/js/ContextProviders/LoadingContext";

function Home() {
    const { loading , startLoading , stopLoading } = useLoading();
    return (
        <>
            <div className="parent-slider">
                <Slider />
            </div>
            <Qualities />
            <div className="parent-categories">
                <Categories />
            </div>
        </>
    )

}

export default Home;